import { Autocomplete, Box, Chip, TextField, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAnnotatorsSelection } from './useAnnotatorsSelection';
import { Annotator, User } from '../../types/response';

export const AnnotatorsSelection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    selectedAnnotators,
    handleRemoveAnnotator,
    annotators,
    annotatorInputValue,
    lastTypedAnnotatorValue,
    setAnnotatorInputValue,
    handleAddAnnotator,
  } = useAnnotatorsSelection();
  return (
    <Box id="annotators-selection">
      <Typography variant="h6">
        {formatMessage({ id: 'adminProjects.allocation.selectAnnotators.title' })}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: theme.spacing(2), p: theme.spacing(2) }}>
        {selectedAnnotators.map((annotator: Annotator) => (
          <Chip
            key={annotator.id}
            label={annotator.label}
            onDelete={() => handleRemoveAnnotator(annotator)}
            sx={{
              backgroundColor: theme.palette.grey[200],
              color: theme.palette.text.primary,
              fontSize: '13px',
              border: 0,
              cursor: 'pointer',
            }}
          />
        ))}
      </Box>
      <Autocomplete
        options={annotators}
        value={null}
        disableCloseOnSelect
        getOptionLabel={(option) => option.label}
        inputValue={annotatorInputValue}
        onInputChange={(event, newInputValue, reason) => {
          if (reason === 'input') {
            lastTypedAnnotatorValue.current = newInputValue;
            setAnnotatorInputValue(newInputValue);
          }
        }}
        onChange={(event, selectedOption) => {
          if (!selectedOption) return;

          handleAddAnnotator(selectedOption as Annotator);

          // restore typed text
          setAnnotatorInputValue(lastTypedAnnotatorValue.current);
        }}
        getOptionDisabled={(option) => selectedAnnotators.some((a) => a.id === option.id)}
        renderOption={(props, option) => {
          const { key, ...otherProps } = props;

          const isSelected = selectedAnnotators.some((a) => a.id === option.id);

          return (
            <Box
              key={key}
              component="li"
              {...otherProps}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                opacity: isSelected ? 0.6 : 1,
              }}
            >
              <span>{option.label}</span>

              {isSelected && (
                <Typography
                  variant="caption"
                  color="primary"
                  sx={{ fontWeight: 600, ml: theme.spacing(2) }}
                >
                  {formatMessage({ id: 'adminProjects.autocomplete.selected' })}
                </Typography>
              )}
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={formatMessage({ id: 'adminProjects.allocation.selectAnnotators.placeholder' })}
          />
        )}
      />
    </Box>
  );
};
